export default __webpack_public_path__ + "static/media/title.0e6494fe.svg";